import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

import {
    Google,
    GoogleTransformers,
    Pixall,
} from 'reaxl-analytics-handlers';

import getInventoryOwnerById from '@/analytics/utilities/getInventoryOwnerById';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

export function ownerGetQuickEstimateClick({
    event,
    state,
    dataLayer,
    data = {},
}, option) {

    const {
        inventoryId,
    } = data;
    const eventText = (event?.target?.innerText || event?.target?.textContent || event?.target?.value || '').trim();
    const linkCopy = _kebabCase(eventText);
    const inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
    const cmp = 'get_q_est';

    Google.sendClickEvent({
        eventElement: 'dhs',
        eventResult: `text-link::${linkCopy}`,
        eventNonInteractive: true,
        eventData: {
            vehicle: {
                ...googleInventoryTransformer(inventoryWithOwner, { target: 'vehicle', dataLayer }),
            },
        },
    }, option);

    return { cmp };
}

export function testDriveScheduleClick({
    data = {},
    state,
    dataLayer,
}, option) {
    const { placement = '', listingId } = data;
    const inventory = getInventoryOwnerById(state, listingId);
    const ownerId = _get(inventory, 'owner.id') || data.ownerId || '';

    const eventResult = `text-link::schedule-test-drive::${placement}`;

    Pixall.sendClickEvent({
        label: `text-link_schedule-test-drive_${placement}`,
        eventSource: 'userAccount',
        listingCode: ownerId,
        inventory,
    }, dataLayer, option);

    Google.sendClickEvent({
        eventElement: 'nds',
        eventResult,
        eventData: {
            vehicle: {
                ...googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }),
            },
        },
    }, option);

    return { cmp: eventResult };

}

export default {
    testDriveScheduleClick,
    ownerGetQuickEstimateClick,
};
